import React from "react";

import { GuessType } from "../../types/guess";
import { Song } from "../../types/song";
import { playTimes } from "../../constants";

import { Button, Guess, Player, Search, Result } from "../";

import * as Styled from "./index.styled";

interface Props {
  guesses: GuessType[];
  songs: Song[];
  todaysSolution: Song;
  currentTry: number;
  didGuess: boolean;
  selectionMessage?: string;
  setSelectedSong: (song: Song | undefined) => void;
  skip: () => void;
  guess: () => void;
}

export function Game({
  guesses,
  songs,
  todaysSolution,
  currentTry,
  didGuess,
  selectionMessage,
  setSelectedSong,
  skip,
  guess,
}: Props) {
  if (didGuess || currentTry === playTimes.length) {
    return (
      <Result
        didGuess={didGuess}
        currentTry={currentTry}
        todaysSolution={todaysSolution}
        guesses={guesses}
      />
    );
  }
  return (
    <>
      {guesses.map((guess: GuessType, index) => (
        <Guess
          key={index}
          guess={guess}
          isCorrect={guess.isCorrect}
          active={index === currentTry}
        />
      ))}
      <Player
        id={todaysSolution.youtubeId}
        currentTry={currentTry}
        startSeconds={todaysSolution.startSeconds}
      />
      <Search
        songs={songs}
        currentTry={currentTry}
        setSelectedSong={setSelectedSong}
      />
      {selectionMessage && (
        <Styled.SelectionMessage role="status">
          {selectionMessage}
        </Styled.SelectionMessage>
      )}

      <Styled.Buttons>
        <Button onClick={skip}>
          {currentTry === playTimes.length - 1
            ? "Give Up"
            : `Skip +${playTimes[currentTry] / 1000}s`}
        </Button>
        <Button variant="green" onClick={guess}>
          Submit
        </Button>
      </Styled.Buttons>
    </>
  );
}
